export type Role = 'dps' | 'tank' | 'skill';

export const BRAND_ROLES: Record<string, Role[]> = {
  '5_11_tactical': ['tank'],
  airaldi_holdings: ['dps'],
  alps_summit_armaments: ['skill'],
  badger_tuff: ['tank', 'dps'],
  belstone_armory: ['tank'],
  brazos_de_arcabuz: ['skill', 'tank'],
  ceska_vyroba_s_r_o: ['dps', 'tank'],
  china_light_industries_corporation: ['skill', 'dps'],
  douglas_harding: ['dps'],
  electrique: ['skill', 'dps'],
  empress_international: ['skill'],
  fenris_group_ab: ['dps'],
  gila_guard: ['tank'],
  golan_gear_ltd: ['tank', 'skill'],
  grupo_sombra_s_a: ['dps'],
  habsburg_guard_hg: ['tank', 'dps'],
  hana_u_corporation: ['skill', 'dps'],
  imminence_armaments: ['dps'],
  legatus_s_p_a: ['dps'],
  lengmo: ['tank', 'dps'],
  murakami_industries: ['skill'],
  overlord_armaments: ['dps'],
  palisade_steelworks: ['tank', 'skill'],
  petrov_defense_group: ['dps'],
  providence_defense: ['dps'],
  richter_kaiser_gmbh: ['skill', 'tank'],
  royal_works: ['dps'],
  shiny_monkey_gear: ['skill', 'tank'],
  sokolov_concern: ['dps'],
  unit_alloys: ['dps'],
  urban_lookout: ['dps', 'skill'],
  uzina_getica: ['tank'],
  walker_harris_co: ['dps'],
  wyvern_wear: ['skill'],
  yaahl_gear: ['tank', 'dps'],
  zwiadowka_sp_z_o_o: ['dps'],
};

export const SET_ROLES: Record<string, Role[]> = {
  aces_eights: ['dps'],
  aegis: ['tank', 'skill'],
  breaking_point: ['dps'],
  cavalier: ['tank'],
  concentrated_company: ['dps'],
  core_strength: ['tank'],
  eclipse_protocol: ['skill'],
  foundry_bulwark: ['tank'],
  future_initiative: ['skill'],
  hard_wired: ['skill'],
  heartbreaker: ['dps'],
  hotshot: ['dps'],
  hunter_s_fury: ['dps'],
  measured_assembly: ['skill', 'dps'],
  negotiator_s_dilemma: ['dps'],
  ongoing_directive: ['dps'],
  ortiz_exuro: ['skill', 'dps'],
  refactor: ['skill'],
  rigger: ['skill'],
  striker_s_battlegear: ['dps'],
  system_corruption: ['tank'],
  tip_of_the_spear: ['dps'],
  tipping_scales: ['dps'],
  true_patriot: ['tank', 'dps'],
  umbra_initiative: ['dps'],
  virtuoso: ['dps'],
};

const FALLBACK_BY_TYPE: Record<string, Role[]> = {
  red: ['dps'],
  blue: ['tank'],
  yellow: ['skill'],
};

export function brandRoles(id: string | null | undefined): Role[] {
  if (!id) return [];
  return BRAND_ROLES[id] ?? [];
}

export function setRoles(id: string | null | undefined, type?: string): Role[] {
  if (!id) return [];
  const explicit = SET_ROLES[id];
  if (explicit) return explicit;
  if (type && FALLBACK_BY_TYPE[type]) return FALLBACK_BY_TYPE[type];
  return [];
}

export const ROLE_LABEL: Record<Role, string> = {
  dps: 'DPS',
  tank: 'TANK',
  skill: 'SKILL',
};
